import axios from 'axios';

import type { CompanyWithRank, ScopedCompanies } from '@sine/sine-core-api-types';

import { SineHeader } from '../../shared/types';

const companyService = {
  async search(key: string) {
    const { data } = await axios.get<Array<CompanyWithRank>>(
      `${window.env.REACT_APP_SINE_CORE_API_URI}/company/search?query=${key}`,
    );

    return data;
  },

  async searchScoped(key: string, teamId: string | undefined) {
    const { data } = await axios.get<ScopedCompanies>(
      `${window.env.REACT_APP_SINE_CORE_API_URI}/company/search-scoped?query=${key}`,
      {
        headers: {
          ...(teamId ? { [SineHeader.X_SINE_TEAM_ID]: teamId } : {}),
        },
      },
    );

    return data;
  },
};

export default companyService;
